import { RouteRecordRaw } from 'vue-router';
import { HomologationDocumentPage } from '@/pages/homologation';

export const routeName = 'HomologacaoDocumento';

export const route: RouteRecordRaw = {
  path: 'homologacao/document/:id',
  name: routeName,
  component: HomologationDocumentPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Documento',
    permissions: [
      { action: 'manageApproval', subject: 'Homologation' },
      { action: 'manageVerification', subject: 'Homologation' },
      { action: 'send', subject: 'Document' },
    ],
    matchMode: 'any',
  },
};
